import { render } from "./TruckTable.vue?vue&type=template&id=c2bb2540&scoped=true"
import script from "./TruckTable.vue?vue&type=script&lang=js"
export * from "./TruckTable.vue?vue&type=script&lang=js"

import "./TruckTable.vue?vue&type=style&index=0&id=c2bb2540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2bb2540"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
